import { FilterParams } from 'interfaces/filters';
import { PaginationParams } from 'interfaces/pagination';
import type { IResponseGetDrivers, IHubDriver } from 'interfaces/Hub';
import { applyQueryString } from 'lib/queryString';
import { apiHub, formDataBuilder } from 'services';
import { DriverDoc, DriverDocPayload } from 'interfaces/driver-doc';
import { DriverCarrier, DriverCarrierPayload } from 'interfaces/driver-carrier';

export function useHubDriver() {
  const getListDrivers = async (
    filters: FilterParams,
    pagination: PaginationParams
  ): Promise<any> => {
    const url = applyQueryString(`/driver`, {
      ...filters,
      ...pagination,
    });
    const { data } = await apiHub.get<IResponseGetDrivers>(url);
    return data;
  };

  const getListDriverDocs = async (
    filters: FilterParams
  ): Promise<DriverDoc[]> => {
    const url = applyQueryString(`/driver-docs`, {
      ...filters,
    });
    const { data } = await apiHub.get<DriverDoc[]>(url);
    return data;
  };

  const addDriverDoc = async (payload: DriverDocPayload) => {
    const dataBuilder = formDataBuilder(payload);

    const { data } = await apiHub.post<DriverDoc[]>(
      `/driver-docs`,
      dataBuilder
    );
    return data;
  };

  const removeDriverDoc = async (driverDocId: number) => {
    const { data } = await apiHub.delete<DriverDoc[]>(
      `/driver-docs/${driverDocId}`
    );
    return data;
  };

  const getListDriverCarriers = async (
    filters: FilterParams
  ): Promise<DriverCarrier[]> => {
    const url = applyQueryString(`/driver-carrier`, {
      ...filters,
    });
    const { data } = await apiHub.get<DriverCarrier[]>(url);
    return data;
  };

  const addDriverCarrier = async (payload: DriverCarrierPayload) => {
    const dataBuilder = formDataBuilder(payload);

    const { data } = await apiHub.post<DriverCarrier[]>(
      `/driver-carrier`,
      dataBuilder
    );
    return data;
  };

  const removeDriverCarrier = async (driverDocId: number) => {
    const { data } = await apiHub.delete<DriverCarrier>(
      `/driver-carrier/${driverDocId}`
    );
    return data;
  };

  const createDriver = async (data: Partial<IHubDriver>): Promise<void> => {
    await apiHub.post('/driver', data);
  };

  const updateDriver = async (data: Partial<IHubDriver>): Promise<void> => {
    await apiHub.put(`/driver/${data.id}`, data);
  };

  const deleteDriver = async (id: number): Promise<void> => {
    await apiHub.delete(`/driver/${id}`);
  };

  const getDriver = async (id: string): Promise<IHubDriver> => {
    const { data } = await apiHub.get(`/driver/${id}`);
    return data;
  };

  return {
    getListDrivers,
    getListDriverDocs,
    addDriverDoc,
    removeDriverDoc,
    getListDriverCarriers,
    addDriverCarrier,
    removeDriverCarrier,
    createDriver,
    updateDriver,
    deleteDriver,
    getDriver,
  };
}
